import { leaves, values } from './dtcg';
/** Colors available to use in 6 or 8 digit hex */
export const DS_COLOR_src = {
    ...leaves('color', {
        /**
         * LIGHT THEME
         */
        /* PRIMARY */
        LIGHT_PRIMARY_MAIN: '#0060A9',
        LIGHT_PRIMARY_DARK: '#00315B',
        LIGHT_PRIMARY_LIGHT: '#EAF1FF',
        LIGHT_PRIMARY_TEXT_CONTRAST: '#FFFFFF',
        // Same as LIGHT_PRIMARY_MAIN but with added transparency
        LIGHT_PRIMARY_4P: '#0060A980',
        LIGHT_PRIMARY_8P: '#0060A914',
        LIGHT_PRIMARY_12P: '#0060A91F',
        LIGHT_PRIMARY_30P: '#0060A94D',
        LIGHT_PRIMARY_50P: '#0060A980',
        /* SECONDARY */
        LIGHT_SECONDARY_MAIN: '#504CCB',
        LIGHT_SECONDARY_DARK: '#1E0C9E',
        LIGHT_SECONDARY_LIGHT: '#F2EFFF',
        LIGHT_SECONDARY_TEXT_CONTRAST: '#FFFFFF',
        // Same as LIGHT_SECONDARY_MAIN but with added transparency
        LIGHT_SECONDARY_4P: '#504CCB4D',
        LIGHT_SECONDARY_8P: '#504CCB14',
        LIGHT_SECONDARY_12P: '#504CCB1F',
        LIGHT_SECONDARY_30P: '#504CCB4D',
        LIGHT_SECONDARY_50P: '#504CCB80',
        /* ERROR */
        LIGHT_ERROR_MAIN: '#D14836',
        LIGHT_ERROR_DARK: '#AF3021',
        LIGHT_ERROR_LIGHT: '#FFEDEA',
        LIGHT_ERROR_TEXT_CONTRAST: '#FFFFFF',
        // Same as LIGHT_ERROR_MAIN but with added transparency
        LIGHT_ERROR_4P: '#D148364D',
        LIGHT_ERROR_8P: '#D1483614',
        LIGHT_ERROR_12P: '#D148361F',
        LIGHT_ERROR_30P: '#D148364D',
        LIGHT_ERROR_50P: '#D1483680',
        LIGHT_ERROR_160P: '#680100',
        LIGHT_ERROR_190P: '#FDE5EE',
        /* WARNING */
        LIGHT_WARNING_MAIN: '#B4611B',
        LIGHT_WARNING_DARK: '#954A00',
        LIGHT_WARNING_LIGHT: '#FFEDE4',
        LIGHT_WARNING_TEXT_CONTRAST: '#FFFFFF',
        // Same as LIGHT_WARNING_MAIN but with added transparency
        LIGHT_WARNING_4P: '#B4611B4D',
        LIGHT_WARNING_8P: '#B4611B14',
        LIGHT_WARNING_12P: '#B4611B1F',
        LIGHT_WARNING_30P: '#B4611B4D',
        LIGHT_WARNING_50P: '#B4611B80',
        LIGHT_WARNING_160P: '#551E00',
        LIGHT_WARNING_190P: '#F8EFE8',
        /* INFO */
        LIGHT_INFO_MAIN: '#007FB2',
        LIGHT_INFO_DARK: '#00658E',
        LIGHT_INFO_LIGHT: '#E5F3FF',
        LIGHT_INFO_TEXT_CONTRAST: '#FFFFFF',
        // Same as LIGHT_INFO_MAIN but with added transparency
        LIGHT_INFO_4P: '#007FB24D',
        LIGHT_INFO_8P: '#007FB214',
        LIGHT_INFO_12P: '#007FB21F',
        LIGHT_INFO_30P: '#007FB24D',
        LIGHT_INFO_50P: '#007FB280',
        LIGHT_INFO_160P: '#053347',
        LIGHT_INFO_190P: '#E5F2F7',
        /* SUCCESS */
        LIGHT_SUCCESS_MAIN: '#488600',
        LIGHT_SUCCESS_DARK: '#386B00',
        LIGHT_SUCCESS_LIGHT: '#D0FFA4',
        LIGHT_SUCCESS_TEXT_CONTRAST: '#FFFFFF',
        // Same as LIGHT_SUCCESS_MAIN but with added transparency
        LIGHT_SUCCESS_4P: '#4886004D',
        LIGHT_SUCCESS_8P: '#48860014',
        LIGHT_SUCCESS_12P: '#4886001F',
        LIGHT_SUCCESS_30P: '#4886004D',
        LIGHT_SUCCESS_50P: '#48860080',
        LIGHT_SUCCESS_160P: '#1E3600',
        LIGHT_SUCCESS_190P: '#EDF3E5',
        /* TEXT */
        LIGHT_TEXT_PRIMARY_HEADER: '#001C38',
        LIGHT_TEXT_SECONDARY_HEADER: '#0D006A',
        LIGHT_TEXT_DISABLED: '#00000061',
        LIGHT_TEXT_BODY: '#1A1A2C',
        LIGHT_TEXT_SUB: '#1A1A2CB2',
        /* ACTION */
        LIGHT_ACTION_ACTIVE: '#00000099',
        LIGHT_ACTION_HOVER: '#0000000A',
        LIGHT_ACTION_SELECTED: '#00000014',
        LIGHT_ACTION_DISABLED: '#00000042',
        LIGHT_ACTION_DISABLED_BACKGROUND: '#0000001F',
        LIGHT_ACTION_FOCUS: '#0000001F',
        /* BACKGROUND */
        LIGHT_BACKGROUND_PAPER: '#FFFFFF',
        LIGHT_BACKGROUND_DEFAULT: '#FFFFFF',
        LIGHT_BACKGROUND_PRIMARY_START: '#E2F6FF',
        LIGHT_BACKGROUND_PRIMARY_END: '#FDF7F9',
        LIGHT_BACKGROUND_SECONDARY_START: '#C2C1FF',
        LIGHT_BACKGROUND_SECONDARY_END: '#FFFBFF',
        /* MISC */
        LIGHT_DIVIDER: '#0000001A',
        LIGHT_OUTLINE_BORDER: '#0000003B',
        LIGHT_INPUT_LINE: '#0000006B',
        LIGHT_BACKDROP_OVERLAY: '#00000080',
        LIGHT_SNACKBAR_BACKGROUND: '#323232',
        // EVE-12884: was '#84FFFF' — that value only clears 3:1 on DARK surfaces
        // (the two hexes were transposed between modes). Swapped to '#303030',
        // which meets the WCAG 1.4.11 non-text 3:1 floor on light surfaces.
        LIGHT_FOCUS_OUTLINE: '#303030',
        /**
         * DARK THEME
         */
        /* PRIMARY */
        DARK_PRIMARY_MAIN: '#FFFFFF',
        DARK_PRIMARY_DARK: '#A2C9FF',
        DARK_PRIMARY_LIGHT: '#EAF1FF',
        DARK_PRIMARY_TEXT_CONTRAST: '#000000CC',
        // Same as DARK_PRIMARY_DARK but with added transparency
        DARK_PRIMARY_8P: '#A2C9FF14',
        DARK_PRIMARY_12P: '#A2C9FF1F',
        DARK_PRIMARY_16P: '#A2C9FF29',
        DARK_PRIMARY_30P: '#A2C9FF4D',
        DARK_PRIMARY_50P: '#A2C9FF80',
        /* SECONDARY */
        DARK_SECONDARY_MAIN: '#F2EFFF',
        DARK_SECONDARY_DARK: '#C2C1FF',
        DARK_SECONDARY_LIGHT: '#FFFBFF',
        DARK_SECONDARY_TEXT_CONTRAST: '#000000DE',
        // Same as DARK_SECONDARY_DARK but with added transparency
        DARK_SECONDARY_8P: '#C2C1FF14',
        DARK_SECONDARY_12P: '#C2C1FF1F',
        DARK_SECONDARY_16P: '#C2C1FF29',
        DARK_SECONDARY_30P: '#C2C1FF4D',
        DARK_SECONDARY_50P: '#C2C1FF80',
        /* ERROR */
        DARK_ERROR_MAIN: '#FFB4A8',
        DARK_ERROR_DARK: '#680100',
        DARK_ERROR_LIGHT: '#FFEDEA',
        DARK_ERROR_TEXT_CONTRAST: '#FFFFFF',
        // Same as DARK_ERROR_MAIN but with added transparency
        DARK_ERROR_8P: '#FFB4A814',
        DARK_ERROR_12P: '#FFB4A81F',
        DARK_ERROR_30P: '#FFB4A84D',
        DARK_ERROR_50P: '#FFB4A880',
        DARK_ERROR_160P: '#FEE1DC',
        DARK_ERROR_190P: '#1A1211',
        /* WARNING */
        DARK_WARNING_MAIN: '#FFB785',
        DARK_WARNING_DARK: '#502500',
        DARK_WARNING_LIGHT: '#FFEDE4',
        DARK_WARNING_TEXT_CONTRAST: '#000000DE',
        // Same as DARK_WARNING_MAIN but with added transparency
        DARK_WARNING_8P: '#FFB78514',
        DARK_WARNING_12P: '#FFB7851F',
        DARK_WARNING_30P: '#FFB7854D',
        DARK_WARNING_50P: '#FFB78580',
        DARK_WARNING_160P: '#FEE2CE',
        DARK_WARNING_190P: '#1A120E',
        /* INFO */
        DARK_INFO_MAIN: '#85CFFF',
        DARK_INFO_DARK: '#001E2E',
        DARK_INFO_LIGHT: '#E5F3FF',
        DARK_INFO_TEXT_CONTRAST: '#000000DE',
        // Same as DARK_INFO_MAIN but with added transparency
        DARK_INFO_8P: '#85CFFF14',
        DARK_INFO_12P: '#85CFFF1F',
        DARK_INFO_30P: '#85CFFF4D',
        DARK_INFO_50P: '#85CFFF80',
        DARK_INFO_160P: '#CEECFF',
        DARK_INFO_190P: '#0D151B',
        /* SUCCESS */
        DARK_SUCCESS_MAIN: '#85DC33',
        DARK_SUCCESS_DARK: '#1A3700',
        DARK_SUCCESS_LIGHT: '#D0FFA4',
        DARK_SUCCESS_TEXT_CONTRAST: '#000000DE',
        // Same as DARK_SUCCESS_MAIN but with added transparency
        DARK_SUCCESS_8P: '#85DC3314',
        DARK_SUCCESS_12P: '#85DC331F',
        DARK_SUCCESS_30P: '#85DC334D',
        DARK_SUCCESS_50P: '#85DC3380',
        DARK_SUCCESS_160P: '#C0F2C8',
        DARK_SUCCESS_190P: '#0D1705',
        /* TEXT */
        DARK_TEXT_PRIMARY_HEADER: '#EAF1FF',
        DARK_TEXT_SECONDARY_HEADER: '#F2EFFF',
        DARK_TEXT_DISABLED: '#FFFFFF80',
        DARK_TEXT_BODY: '#FFFFFF',
        DARK_TEXT_SUB: '#FFFFFFB2',
        /* ACTION */
        DARK_ACTION_ACTIVE: '#FFFFFFCC',
        DARK_ACTION_HOVER: '#FFFFFF14',
        DARK_ACTION_SELECTED: '#FFFFFF29',
        DARK_ACTION_DISABLED: '#FFFFFF4D',
        DARK_ACTION_DISABLED_BACKGROUND: '#FFFFFF1F',
        DARK_ACTION_FOCUS: '#FFFFFF1F',
        /* BACKGROUND */
        DARK_BACKGROUND_PAPER: '#1A1A2C',
        DARK_BACKGROUND_DEFAULT: '#121212',
        DARK_BACKGROUND_PRIMARY_START: '#2B3B72',
        DARK_BACKGROUND_PRIMARY_END: '#1F54B2',
        DARK_BACKGROUND_SECONDARY_START: '#504CCB',
        DARK_BACKGROUND_SECONDARY_END: '#8482FF',
        /* MISC */
        DARK_DIVIDER: '#FFFFFF1F',
        DARK_OUTLINE_BORDER: '#FFFFFF3B',
        DARK_INPUT_LINE: '#FFFFFF6B',
        DARK_BACKDROP_OVERLAY: '#FFFFFF80',
        DARK_SNACKBAR_BACKGROUND: '#323232',
        DARK_BUTTON_LABEL_ICON: '#004881',
        // EVE-12884: was '#303030' — that value only clears 3:1 on LIGHT surfaces
        // (the two hexes were transposed between modes). Swapped to '#84FFFF',
        // which meets the WCAG 1.4.11 non-text 3:1 floor on dark surfaces.
        DARK_FOCUS_OUTLINE: '#84FFFF',
        /**
         * COMMON
         */
        BLACK_4P: '#0000000A',
        BLACK_12P: '#0000001F',
        BLACK_20P: '#00000033',
        BLACK_40P: '#00000066',
        BLACK_60P: '#00000099',
        BLACK_80P: '#000000CC',
        BLACK_100P: '#000000',
        WHITE_8P: '#FFFFFF14',
        WHITE_12P: '#FFFFFF1F',
        WHITE_20P: '#FFFFFF33',
        WHITE_30P: '#FFFFFF4D',
        WHITE_40P: '#FFFFFF66',
        WHITE_60P: '#FFFFFF99',
        WHITE_80P: '#FFFFFFCC',
        WHITE_100P: '#FFFFFF',
        GREY: '#F5F5F5',
        GREY_400: '#BDBDBD',
        GREY_600: '#757575',
        /* GRAPH */
        GRAPH_MINIMAL: '#75B8E7',
        GRAPH_MILD: '#77F094',
        GRAPH_MODERATE: '#F7FA81',
        GRAPH_MODERATE_SEVERE: '#FCC067',
        GRAPH_SEVERE: '#F07889',
        /* GRADIENT COLORS */
        LIGHT_GRADIENT_BACKGROUND_PRIMARY_TOP: '#E2F6FF',
        LIGHT_GRADIENT_BACKGROUND_PRIMARY_BOTTOM: '#FDF7F9',
        LIGHT_GRADIENT_BACKGROUND_SECONDARY_TOP: '#C2C1FF',
        LIGHT_GRADIENT_BACKGROUND_SECONDARY_BOTTOM: '#FFFBFF',
        LIGHT_GRADIENT_BACKGROUND_VIDEO_TOP: '#9E82F7',
        LIGHT_GRADIENT_BACKGROUND_VIDEO_BOTTOM: 'rgba(0, 0, 0, 0)',
        LIGHT_GRADIENT_ICON_PRIMARY_TOP: '#4A93E5',
        LIGHT_GRADIENT_ICON_PRIMARY_BOTTOM: '#504CCB',
        LIGHT_GRADIENT_ICON_SECONDARY_TOP: '#504CCB',
        LIGHT_GRADIENT_ICON_SECONDARY_BOTTOM: '#8482FF',
        LIGHT_GRADIENT_HERO_TOP: 'rgba(226, 246, 255, 0)',
        DARK_GRADIENT_BACKGROUND_HERO_TOP: '#294081',
        DARK_GRADIENT_BACKGROUND_PRIMARY_TOP: '#2B3B72',
        DARK_GRADIENT_BACKGROUND_PRIMARY_BOTTOM: '#1F54B2',
        DARK_GRADIENT_BACKGROUND_SECONDARY_TOP: '#504CCB',
        DARK_GRADIENT_BACKGROUND_SECONDARY_BOTTOM: '#8482FF',
        DARK_GRADIENT_BACKGROUND_VIDEO_TOP: '#353F77',
        DARK_GRADIENT_BACKGROUND_VIDEO_BOTTOM: 'rgba(0, 0, 0, 0)',
        DARK_GRADIENT_ICON_PRIMARY_TOP: '#4A93E5',
        DARK_GRADIENT_ICON_PRIMARY_BOTTOM: '#504CCB',
        DARK_GRADIENT_ICON_SECONDARY_TOP: '#504CCB',
        DARK_GRADIENT_ICON_SECONDARY_BOTTOM: '#8482FF',
        DARK_GRADIENT_HERO_TOP: 'rgba(39, 64, 128, 0)',
        GRADIENT_SHADER_LIGHT: 'rgba(255, 255, 255, 0.72)',
        GRADIENT_SHADER_DARK: 'rgba(0, 0, 0, 0.23)',
        CALM_GRADIENT_BRAND_TOP: '#60B4E7',
        CALM_GRADIENT_BRAND_BOTTOM: '#6461E0',
        CALM_GRADIENT_BRAND_ACCESSIBLE_TOP: '#2477AA',
        CALM_GRADIENT_BRAND_ACCESSIBLE_BOTTOM: '#6461E0',
        /* SHADOW COLORS */
        SHADOW_POD: '#23113e1a',
    }),
};
export const DS_COLOR = values(DS_COLOR_src);
//# sourceMappingURL=colors.js.map